import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import moment from 'moment';
import {
  EstateInputDataFormatDataType,
  EstateInputDataFormatType,
  EstateInputDataInstance_FieldsFragment,
} from 'queries';

const useStyles = makeStyles(() => ({
  requiredInfoDetails: {
    fontSize: '12px',
    color: '#9DA8B4',
  },
  container: {
    border: '1px solid #ECEEF1',
    borderRadius: '8px',
    padding: '8px',
    boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.05)',
    marginTop: '8px',
  },
}));

type Props = {
  estateInputDataInstance: EstateInputDataInstance_FieldsFragment;
};

const EstateInputDataInstanceDetail = ({ estateInputDataInstance }: Props) => {
  const classes = useStyles();

  const displayData = () => {
    if (!estateInputDataInstance.data) {
      return 'N/A';
    }

    if (
      estateInputDataInstance.estateInputDataFormat!.type === EstateInputDataFormatType.Document
    ) {
      return 'Uploaded';
    }

    switch (estateInputDataInstance.estateInputDataFormat!.dataType) {
      case EstateInputDataFormatDataType.Date:
        return moment(new Date(estateInputDataInstance.data)).format('MM/DD/YYYY');

      case EstateInputDataFormatDataType.YesNo:
        if (estateInputDataInstance.data.toLowerCase() === 'true') {
          return 'Yes';
        }
        return 'No';

      case EstateInputDataFormatDataType.TextSingleLine:
      case EstateInputDataFormatDataType.TextMultiLine:
      case EstateInputDataFormatDataType.Number:
      case EstateInputDataFormatDataType.NumberNoDecimal:
      case EstateInputDataFormatDataType.List:
      default:
        return estateInputDataInstance.data;
    }
  };

  return (
    <Box className={classes.container}>
      <div>{estateInputDataInstance.estateInputDataFormat?.name}</div>
      <Typography className={classes.requiredInfoDetails}>{displayData()}</Typography>
    </Box>
  );
};

export default EstateInputDataInstanceDetail;
